export const FORMAT_DATE_SHORT = 'MM/dd/yyyy';
